import { render, staticRenderFns } from "./soleHome.vue?vue&type=template&id=e52534a0&scoped=true&"
import script from "./soleHome.vue?vue&type=script&lang=js&"
export * from "./soleHome.vue?vue&type=script&lang=js&"
import style0 from "./soleHome.vue?vue&type=style&index=0&id=e52534a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52534a0",
  null
  
)

export default component.exports